/**
 * Codemade OÜ
 *
 * Bootstrapping of the VueJS application
 *
 * @summary Bootstrapping of the VueJS application
 * @author Borka Martin Orlov
 *
 * Created at     : 2020-08-11 21:28:30
 * Last modified  : 2021-03-28 11:44:47
 */

import Toasted from 'vue-toasted';
import Vue from 'vue';
import VueCarousel from 'vue-carousel';
import VueRouter from 'vue-router';
import infiniteScroll from 'vue-infinite-scroll';
import VueEllipseProgress from 'vue-ellipse-progress';
import vToolTip from 'v-tooltip';
import VueMeta from 'vue-meta';


/**
 * Load Lodash
 */
window._ = require('lodash');


/**
 * Load Vue router
 */
Vue.use(VueRouter);


/**
 * For setting metadata across pages
 */
Vue.use(VueMeta);


/**
 * Load Vue-toasted
 */
Vue.use(Toasted);


/**
 * Load VueCarousel
 */
Vue.use(VueCarousel);


/**
 * Infinite scroll for deals
 */
Vue.use(infiniteScroll);


/**
 * Vue Progressbar for levels
 */
Vue.use(VueEllipseProgress);


/**
 * V-Tooltip for tooltips
 */
Vue.use(vToolTip, {
    defaultTrigger: 'hover focus click',
});


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios').default;


/**
 * Set defaulty parameters for axios requests.
 * Laravel does checks for content-type so application/json is preferred for us.
 */
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
